export default "__VITE_ASSET__BtvA4z8Z__"